//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import eppContext from '../../context/eppContext/eppContex';
import './FormEpp.css';

function FormEpp({data, setData, minimizar, nuevoEditado, handleChangeEpps, index, tDocID = '' }){

    const eContext = useContext(eppContext);
    const {agregarEpp, actualizarEppLista, modificarEpp, eliminarEpp} = eContext;

    const [epp, setEpp] = useState({codEpp:"",name: ''});

    const [titulo, setTitulo] = useState(nuevoEditado);

    const validacion =  () => {
        const newErrors = {};
        if (epp.codEpp === '' || epp.codEpp === undefined) return newErrors.codigo = 'El código de EPP debe ser colocado'
        if (epp.name === '' || epp.name === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {

        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = epp;
                const res = await agregarEpp(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo EPP`,
                        icon: 'success',
                        text: `Código: ${res.codEpp} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarEppLista();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del EPP",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {

            try {
                const dato = {
                    id: data.id,
                    codEpp:epp.codEpp,
                    name: epp.name
                }
                await setData(dato);
                const res = await modificarEpp(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el EPP`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codEpp}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarEppLista();
                    minimizar();
                    let eppToChange = {id:res._id, label:res.name, value:res.codEpp, name:res.name};
                    handleChangeEpps(eppToChange,index);
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del EPP",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este EPP?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
                const id = data.id
                const resp = await eliminarEpp(id, tDocID);
                if(resp.data.delete){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El EPP fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarEppLista();
                    handleChangeEpps({},index);
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            let codigoEpp = (data.codEpp != undefined) ? data.codEpp : data.value;
            let eppModelado = {id:data?.eppID, codEpp:codigoEpp, name: data?.name};
            setEpp(eppModelado);
        }
    },[data])

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Elemento Protección Personal
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de EPP: </div>
                <input disabled={ titulo === "Modificar"} value={epp.codEpp} className='label-form-group-data' onChange={data => setEpp({ ...epp, ['codEpp']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={epp.name} className='label-form-group-data' onChange={data => setEpp({ ...epp, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormEpp;
